<script>
  import { goto } from "@sveltech/routify";

  $goto("structures");
</script>
